const icon = require('vue-svgicon');
icon.register({
    'check': {
        width: 10,
        height: 10,
        viewBox: '0 0 10 10',
        data: `<path pid="0" d="M7.678 1.667l-.767.8-3.089 3.089-.9-.867-.8-.8L.556 5.456l.8.8 1.666 1.666.767.8.8-.8 3.889-3.889.8-.8-1.6-1.566z"/>`,
    },
});
